/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { InteractiveComponents } from '../../../core/enums';
import { RootState, useTivoSelector } from '../../../core/tivo/tivo-redux-wrapper';
import { Caret } from '../../common';

import './InteractiveLayer.scss';

const InteractiveLayer: FunctionComponent = (): JSX.Element => {
    const activeComponent = useTivoSelector(
        (state: RootState) => state.interactiveLayer.activeComponent,
    );
    const isCaretVisible = useTivoSelector(
        (state: RootState) => state.listViewScreen.isCaretVisible,
    );

    return (
        <React.Fragment>
            <Caret
                direction={InteractiveComponents.NORTH}
                visible={isCaretVisible && activeComponent === InteractiveComponents.NORTH}
                active={activeComponent === InteractiveComponents.NORTH}
                className="list-screen-north"
            />

            <Caret
                direction={InteractiveComponents.SOUTH}
                visible={isCaretVisible && activeComponent === InteractiveComponents.SOUTH}
                active={activeComponent === InteractiveComponents.SOUTH}
                className="list-screen-south"
            />
        </React.Fragment>
    );
};

export default InteractiveLayer;
